import React, { useEffect, useState } from 'react';

import { Image, ImageProps, useMantineTheme } from '@mantine/core';
import { useMediaQuery } from '@mantine/hooks';
import avatarDark from 'assets/images/avatar_dark.png';
import brandDark from 'assets/images/brand_dark.png';
import { useUserContext } from 'contexts/UserContext';
import { OnboardingStepTemplate } from 'pages/Onboarding/OnboardingSteps/OnboardingStepTemplate';
import { useTranslation } from 'react-i18next';

export function WelcomeStep() {
  const theme = useMantineTheme();
  const { t } = useTranslation();
  const [user] = useUserContext();

  const showBranding = useMediaQuery(`(min-width: ${theme.breakpoints.md})`);

  // Save imageProps as state and update it with useEffect to prevent rendering the wrong image initially
  // because useMediaQuery doesnt return the correct value on the first render
  const [imageProps, setImageProps] = useState<ImageProps>();

  useEffect(() => {
    setImageProps({
      src: showBranding ? brandDark : avatarDark,
      maw: showBranding ? 200 : 150
    });
  }, [showBranding]);

  return (
    <OnboardingStepTemplate
      title={{
        text: t('ONBOARDING.WELCOME_STEP.TITLE', { name: user.firstName })
      }}
      description={t('ONBOARDING.WELCOME_STEP.DESCRIPTION')}
      rightElement={<Image {...imageProps} />}
    />
  );
}
